module.exports = __webpack_public_path__ + "static/fonbet-5dd8c633a4aaf2ed4ec506fec315ee7a.gif";